<mat-card class="totalizer-card" [class.hero]="hero" [class.clickable]="clickable"
    [attr.data-test]="'totalizer-card-' + label" [attr.tabindex]="clickable ? 0 : null"
    [attr.role]="clickable ? 'button' : null" (click)="onClick()" (keydown.enter)="onClick()">
    <div class="totalizer-label-row">
        <span class="totalizer-label">{{ label }}</span>
        <i class="material-icons totalizer-tooltip-icon" *ngIf="tooltip" [matTooltip]="tooltip">info_outline</i>
    </div>
    <div class="totalizer-value-row">
        <i class="material-icons totalizer-icon" [ngClass]="'icon-' + iconColor">{{ icon }}</i>
        <span class="totalizer-value" data-test="texto-valor-card" *ngIf="!hidden">{{ value }}</span>
        <div class="totalizer-value-hidden" *ngIf="hidden">
            <i class="material-icons">circle</i>
            <i class="material-icons">circle</i>
            <i class="material-icons">circle</i>
        </div>
        <i class="material-icons totalizer-details-icon" *ngIf="detailsIcon" [matTooltip]="detailsTooltip">chevron_right</i>
    </div>
</mat-card>
